import { render, staticRenderFns } from "./recoletas.vue?vue&type=template&id=43f22df7&"
import script from "./recoletas.vue?vue&type=script&lang=js&"
export * from "./recoletas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports